import useAppModernisation from "../../hooks/useAppModernisation";
import TemplateMenu from "./Menu";
import ResourceMenu from "./ResourceMenu";

/**
 * Router component that switches between app and legacy resource views
 * based on the current app mode and URL path
 */
const ResourceRouter = () => {
  const { isAppMode, isWebModernisationEnabled } = useAppModernisation();

  if (isAppMode) {
    return <TemplateMenu />;
  }

  if (isWebModernisationEnabled) {
    return <ResourceMenu />;
  }

  return <TemplateMenu />;
};

export default ResourceRouter;
